import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerChessMateTranslations } from "./i18n";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  ChessMateDefinition,
  ChessMateProgress,
  ChessMateSolution,
  ChessMateSubmission,
} from "./types";

registerChessMateTranslations(i18n);

export const chessMateModule: PuzzleTypeModule<
  ChessMateDefinition,
  ChessMateSubmission,
  ChessMateProgress,
  ChessMateSolution
> = {
  key: "chess_mate",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
};
